import RMarketChanges from "../responsive/dashboard/RMarketChanges";
import {useState} from "react";
import {AnimatePresence} from "framer-motion";
import {useTradePrice} from "../../contexts/trade-price";
import RMain from "../responsive/dashboard/RMain";
import RTrade from "../responsive/dashboard/RTrade";


const Mobile = () => {

    const { setTradePrice } = useTradePrice()
    const [page, setPage] = useState(0)
    const onBackClicked = () => setPage(0)

    const onTradeBtnClicked = (type) => {
        setTradePrice(state => ({
            ...state, type: type === 'buy' ? 'sell' : 'buy'
        }))
        setPage(1)
    }

    return (
        <>
            <RMarketChanges
                page={page}
                onBackClicked={onBackClicked}
            />
            <AnimatePresence exitBeforeEnter>
                {page === 0 &&
                    <RMain
                        onTradeBtnClicked={onTradeBtnClicked}
                    />
                }
                {page === 1 &&
                    <RTrade />
                }
            </AnimatePresence>
        </>

    )
}





export default Mobile
